export default __webpack_public_path__ + "static/media/Welcome.fe9fa361.png";